// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1.blog-listing-heading {\n  margin: 18% 0 7%;\n  color: white;\n  text-align: center;\n  font-size: 3em;\n}\n@media (max-width: 480px) {\n  h1.blog-listing-heading {\n    margin-top: 30%;\n  }\n}\n.blog-listings {\n  display: flex;\n  flex-wrap: wrap;\n}\n@media (min-width: 768px) {\n  .blog-listings {\n    padding: 0 20%;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
